// src/app/views/pages_user/leet/rtUsLeet.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { getPathByCdExt } from "app/utils/utils";
import { EXAM_TYPES } from "app/types/examTypes";

const UsLeetList = Loadable(lazy(() => import("./UsLeetList")));
const UsLeetExamExam = Loadable(lazy(() => import("./UsLeetExam")));
const ApplicationLogin = Loadable(lazy(() => import("./ApplicationLogin")));
const ApplicationInfo = Loadable(lazy(() => import("./ApplicationInfo")));
const PaymentResult = Loadable(lazy(() => import("./PaymentResult")));
const Login = Loadable(lazy(() => import("./Login")));
const UsLeetExamReview = Loadable(lazy(() => import("./UsLeetExamReview")));
const pathExt = getPathByCdExt(EXAM_TYPES.LEET.rid_cd_ext);

const rtUsLeet = [
  { path: `/user/${pathExt}/login`, element: <Login /> },
  { path: `/user/${pathExt}/applogin`, element: <ApplicationLogin /> },
  { path: `/user/${pathExt}/application-info`, element: <ApplicationInfo /> },
  { path: `/user/${pathExt}/payment-result`, element: <PaymentResult /> },
  { path: `/user/${pathExt}/list/:rid_cd_ext/:rid_user`, element: <UsLeetList /> },
  { path: `/user/${pathExt}/exam/:rid_cd_ext/:rid_user/:rid_imp`, element: <UsLeetExamExam /> },
  { path: `/user/${pathExt}/exam/review/:rid_cd_ext/:rid_imp/:rid_subj/:rid_user/:num_answer`, element: <UsLeetExamReview /> }
];
export default rtUsLeet;
